module.exports = __webpack_public_path__ + "img/linkedin_icon.ac0905c1.png";